<mat-form-field (click)="$event.stopPropagation()">
	<mat-label>{{ question.label | translate }}</mat-label>
	<fitech-workspace-mat-select
		[isRefreshButton]="false"
		[isSelectButtons]="isSelectButtons"
		[showAddNewItem]="showAddNewItem"
		[multiple]="!singleSelect"
		[forceClosingOnClickOutside]="true"
		[items]="items"
		[formControl]="matSelectControl"
		(selectedAll)="selectAll()"
		(clearedAll)="clearAll()"
		(addedNewItem)="addNewItem($event)"
		(openedChange)="changeOpened()">
	</fitech-workspace-mat-select>
</mat-form-field>
